// SectionText.tsx
import React from 'react';
import './SectionText.css';

interface SectionTextProps {
    title: string;
    text: string;
    disclaimer?: string;
    className?: string; // Optional, für zusätzliche CSS-Klassen
}

const SectionText: React.FC<SectionTextProps> = ({ title, text, disclaimer, className }) => {
    return (
        // Füge die `className` Prop zu den bestehenden Klassen hinzu
        <div className={`section-text ${className || ''}`}>
            <h2>{title}</h2>
            <p>{text}</p>
            {disclaimer && <p className="disclaimer">{disclaimer}</p>}
        </div>
    );
};

export default SectionText;
